import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { envTemplate } from "./envTemplate";
import { IEnvironnements } from "./environnements";
import { useAppSelector } from "../../hooks/hooks";

export const DropDownEnv = ({
  envSelected,
  setSelectedEnv,
  disabled,
}: {
  envSelected: IEnvironnements | undefined;
  setSelectedEnv: (envs: IEnvironnements) => void;
  disabled?: boolean;
}) => {
  const environnements = useAppSelector((state) => state.app.config.environnements)
  return (
    <Dropdown
      value={envSelected}
      disabled={disabled}
      onChange={(e: DropdownChangeEvent) => setSelectedEnv(e.value)}
      options={environnements}
      optionLabel="name"
      placeholder="Selectionner un environnement"
      className="w-full"
      itemTemplate={envTemplate}
      valueTemplate={envTemplate} 
    />
  );
};
